import { render, staticRenderFns } from "./SupportSettings.vue?vue&type=template&id=c13854fa&lang=pug&"
import script from "./SupportSettings.vue?vue&type=script&lang=js&"
export * from "./SupportSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports